import React, { useState } from 'react';

// A hub error surface shaped like the Now/Clients insight card (icon · heading ·
// body) but in the RED theme, so a failed load reads as the same kind of surface
// as the insight takeaway — never a bare one-line banner. Optional retry, and a
// close button that dismisses the card (dismissible by default).
export default function ErrorCard({
  title = 'Temporarily unavailable',
  message = "This view isn't loading right now. Please try again shortly.",
  onRetry,
  onClose,
  dismissible = true,
  className = '',
}) {
  const [closed, setClosed] = useState(false);
  if (closed) return null;

  const handleClose = () => {
    setClosed(true);
    onClose?.();
  };

  return (
    <div
      role="alert"
      className={`rounded-xl border border-red-200 bg-red-50 p-4 dark:border-red-800/60 dark:bg-red-900/20 ${className}`}
    >
      <div className="flex items-start gap-3">
        <svg className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500 dark:text-red-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
        <div className="min-w-0 flex-1">
          <h3 className="mb-1 text-sm font-semibold text-red-800 dark:text-red-300">{title}</h3>
          <p className="text-sm leading-relaxed text-red-700 dark:text-red-300">{message}</p>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="mt-3 rounded-lg border border-red-300 bg-white px-3 py-1.5 text-sm font-medium text-red-700 transition-colors hover:bg-red-100 dark:border-red-800 dark:bg-transparent dark:text-red-300 dark:hover:bg-red-900/30"
            >
              Try again
            </button>
          )}
        </div>
        {dismissible && (
          <button
            type="button"
            onClick={handleClose}
            aria-label="Dismiss"
            className="-mr-1 -mt-1 flex-shrink-0 rounded-md p-1 text-red-400 transition-colors hover:bg-red-100 hover:text-red-600 dark:hover:bg-red-900/30 dark:hover:text-red-300"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
